/* src/app/shared/desktop-header/desktop-header.component.scss */
::ng-deep .popover-menu::part(content) {
  width: 250px;
  border-radius: 0;
  top: 75px !important;
  transform: translateX(35px);
}
::ng-deep .popover-menu::part(arrow) {
  display: none;
}
.avatar {
  height: 40px;
  width: 40px;
  margin: auto;
  margin-right: -10px;
}
.menu-button ion-button {
  font-size: 20px;
  margin-left: 18px;
  margin-right: 18px;
}
.loginButton {
  padding: 0;
  height: 30px;
  --border-radius: 5px;
  font-weight: 400;
}
ion-button {
  font-family: "League spartan", sans-serif;
  font-size: 18px;
}
ion-button ion-icon,
ion-button span {
  color: white;
}
ion-button svg,
ion-button ion-icon {
  fill: white;
  width: 24px;
  margin-right: 7px;
}
ion-button:hover {
  opacity: 1 !important;
}
ion-button:hover ion-icon,
ion-button:hover span,
ion-button:hover ion-label {
  color: var(--ion-color-secondary) !important;
}
ion-button:hover svg,
ion-button:hover ion-icon {
  fill: var(--ion-color-secondary) !important;
}
.option-text {
  color: white;
}
ion-toolbar {
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.5);
  --background: black;
}
@media screen and (min-width: 1199px) {
  ion-toolbar div.main {
    padding: 10px 70px 10px 50px;
  }
}
.help-button {
  padding: 0 0 !important;
  margin-inline: 0px !important;
}
.help-button::part(native) {
  padding-inline-end: 0px !important;
  padding-inline-start: 0px !important;
  padding: 0 !important;
}
.help-button svg {
  width: 30px;
  height: 30px;
}
.shoppingCartIcon {
  width: 30px !important;
  height: 30px !important;
}
.loginSection ion-button {
  --color: white !important;
  transition: all 0.2s ease-in-out;
  font-family: "League Spartan", sans-serif;
  font-weight: 500;
  font-size: 18px;
  --border-radius: 10px;
  height: auto !important;
}
.loginSection ion-button::part(native) {
  background: black;
  transition: all 0.2s ease-in-out;
  padding: 8px 11px 6px 11px;
}
.loginSection ion-button:first-of-type::part(native) {
  border: 1px solid white;
}
.loginSection ion-button:hover {
  opacity: 1 !important;
  transition: all 0.2s ease-in-out;
}
.loginSection ion-button:hover:nth-of-type(1)::part(native) {
  background: var(--ion-color-secondary) !important;
  border: 1px solid var(--ion-color-secondary) !important;
}
.loginSection ion-button:hover:nth-of-type(2) {
  --color: var(--ion-color-secondary) !important;
}
ion-toolbar ion-badge {
  width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 0;
}
/*# sourceMappingURL=desktop-header.component-EWEOZQGL.css.map */
